<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "StoryTitle",
  elementPanelSettings: {
    displayName: "Story Title",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: UrlElement,
  mixins: [BaseStoryCardElementMixin],
  options: [
    StoryCardClickBehavior,
  ],
  computed: {
    label() {
      return this.entity.title;
    },
    computedHref() {
      return this.storyHref;
    },
  },
};
</script>
